import React, { useEffect, useState } from 'react';
import DashboardCalendar from './DashboardCalendar';
import { apiFetch } from '../api';

export default function AdminDashboard({ semesters, loadSemesters }) {
  const [activeSemester, setActiveSemester] = useState(null);
  const [newActiveId, setNewActiveId] = useState('');
  const [stats, setStats] = useState({ total: 0, bachelor: 0, master: 0 });

  const fetchActiveSemester = async () => {
    const res = await apiFetch('get_active_semester.php');
    const data = await res.json();

    if (data && data.id) {
      setActiveSemester(data);
      setNewActiveId(data.id);
      fetchStats(data.short);
    } else {
      setActiveSemester(null);
      setNewActiveId('');
      setStats({ total: 0, bachelor: 0, master: 0 });
    }
  };

const fetchStats = async (semesterShort) => {
  const res = await apiFetch(`get_course_stats.php?semester=${semesterShort}`);
  const data = await res.json();
  setStats(data);
};

  const setNewActiveSemester = async () => {
    if (!newActiveId) {
      alert("Keine gültige ID ausgewählt.");
      return;
    }

    const res = await apiFetch('set_active_semester.php', {
      method: 'POST',
      body: JSON.stringify({ id: newActiveId }),
    });

    const result = await res.json();
    alert(result.message || result.error);
    fetchActiveSemester();
    loadSemesters();
  };

  useEffect(() => {
    fetchActiveSemester();
  }, []);

  return (
    <div className="section">
      <h2>Aktives Semester verwalten</h2>

      {activeSemester ? (
        <p><strong>Aktiv:</strong> {activeSemester.name} ({activeSemester.short})</p>
      ) : (
        <p>Kein aktives Semester gesetzt.</p>
      )}

      <div style={{ marginTop: '1rem' }}>
        <label>Neues aktives Semester wählen:</label><br />
        <select
          value={newActiveId}
          onChange={(e) => setNewActiveId(e.target.value)}
        >
          <option value="">-- wählen --</option>
          {semesters.map(s => (
            <option key={s.id} value={s.id}>{s.name} ({s.short})</option>
          ))}
        </select>
        <button className="primary" style={{ marginLeft: '1rem' }} onClick={setNewActiveSemester}>
          Aktiv setzen
        </button>
      </div>

      {activeSemester && (
        <div className="dashboard-cards" style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
          <div className="card" style={{ flex: 1 }}>
            <h3>Kurse insgesamt</h3>
            <p style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{stats.total}</p>
          </div>
          <div className="card" style={{ flex: 1 }}>
            <h3>Bachelor</h3>
            <p style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{stats.bachelor}</p>
          </div>
          <div className="card" style={{ flex: 1 }}>
            <h3>Master</h3>
            <p style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{stats.master}</p>
          </div>
        </div>
      )}
    {activeSemester && activeSemester.short && (
  <DashboardCalendar semesterShort={activeSemester.short} />
)}

    </div>
  );
}
